module.exports = __webpack_public_path__ + "img/betting.81ee1428.jpeg";